import React from "react";
import { MdSummarize, MdOutlineAnalytics, MdVerified } from "react-icons/md";
import AIThinkingLoader from "../common/AIThinkingLoader";

const AIInfrastructureSummary = ({ reportData, loading }) => {
  if (loading) {
    return <AIThinkingLoader />;
  }

  if (!reportData) {
    return (
      <div className="mt-4 sm:mt-6 rounded-xl border border-primary-cyan/20 overflow-hidden" style={{ backgroundColor: "#10182b" }}>
        <div className="p-4 sm:p-6 text-center">
          <p className="text-gray-400 text-sm sm:text-base">No infrastructure summary available</p>
        </div>
      </div>
    );
  }

  const hasSummary = reportData.aiInfrastructureSummary && reportData.aiInfrastructureSummary.trim() !== "";

  if (!hasSummary) {
    return (
      <div className="mt-4 sm:mt-6 rounded-xl border border-primary-cyan/20 overflow-hidden" style={{ backgroundColor: "#10182b" }}>
        <div className="p-4 sm:p-6 text-center">
          <p className="text-gray-400 text-sm sm:text-base">No infrastructure summary available for this period</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4 sm:mt-6 rounded-xl border border-primary-cyan/20 overflow-hidden transition-all duration-300 hover:border-primary-cyan/40 hover:shadow-lg hover:shadow-primary-cyan/10" style={{ backgroundColor: "#10182b" }}>
      <div className="p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-primary-cyan/30 to-primary-cyan/10 flex items-center justify-center shadow-lg shadow-primary-cyan/20">
              <MdSummarize className="text-primary-cyan text-xl sm:text-2xl" />
            </div>
            <div>
              <span className="text-primary-cyan text-xs sm:text-sm font-bold uppercase tracking-wide">
                AI Infrastructure Summary
              </span>
              <div className="flex items-center gap-1 mt-1">
                <MdVerified className="text-primary-cyan text-xs" />
                <span className="text-gray-500 text-[10px] sm:text-xs">AI-Generated Report</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="rounded-xl p-4 sm:p-6 transition-all duration-300 hover:scale-[1.01] relative overflow-hidden" style={{ backgroundColor: "#1c2436" }}>
          <div className="absolute top-0 right-0 w-16 h-16 sm:w-20 sm:h-20 bg-primary-cyan/5 rounded-full blur-2xl"></div>
          <div className="absolute bottom-0 left-0 w-16 h-16 sm:w-20 sm:h-20 bg-primary-cyan/5 rounded-full blur-2xl"></div>
          
          <div className="flex gap-3 sm:gap-4 relative z-10">
            <div className="w-1 h-auto rounded-full bg-gradient-to-b from-primary-cyan to-primary-cyan/40 flex-shrink-0"></div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2 sm:mb-3">
                <div className="w-1 h-1 rounded-full bg-primary-cyan animate-pulse"></div>
                <span className="text-primary-cyan text-[10px] sm:text-xs font-semibold uppercase tracking-wider">Executive Summary</span>
                <div className="w-1 h-1 rounded-full bg-primary-cyan animate-pulse"></div>
              </div>
              <p className="text-gray-200 text-sm sm:text-base leading-relaxed font-medium break-words">
                {reportData.aiInfrastructureSummary}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIInfrastructureSummary;